import { action, withoutPayload } from '../../../utility/redux';

export const appInit = action('APP_INIT', withoutPayload);
